// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"230":"component---src-pages-index-jsx","354":"component---src-pages-about-jsx","661":"component---src-pages-contact-jsx"}[chunkId] + "-" + {"230":"622f10114be1ca666af6","354":"2637cfd4c06dce2919c3","661":"d01776b91b09a2105517"}[chunkId] + ".js";
};